import {MainServices} from "../../consts.js";

export const CategoryTextToOriginalCategories = {
    [MainServices.HAPPY_HOURS]: [MainServices.HAPPY_HOURS, MainServices.PLATTERS],
    [MainServices.PACKAGES]: [MainServices.PACKAGES],
    [MainServices.WORKSHOPS]: [MainServices.WORKSHOPS]
};

export const FILTER_VERSION = 2;
